import { Component } from '@angular/core';
import { ChatBotV2DataService } from '../../../services/chat-bot-v2/chat-bot-v2.data.service';

@Component({
  selector: 'app-chat-bot-asesor-v2-dialog-feedback',
  templateUrl: './chat-bot-asesor-v2-dialog-feedback.component.html',
})
export class ChatBotAsesorV2DialogFeedbackComponent {

  comentario: string = '';

  constructor(
    public chatBotV2DS: ChatBotV2DataService,
  ) { }
  
}
